export default __webpack_public_path__ + "static/media/gate-aviation.5b41c056.jpg";